var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "heart-container"
  }, [_c('button', {
    staticClass: "heart-button",
    class: {
      active: _vm.isInWishlist
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.toggleWishlist(_vm.reference, $event);
      }
    }
  }, [_c('span', {
    staticClass: "container-icon",
    class: {
      'without-label': !_vm.withText
    }
  }, [_c('i', {
    staticClass: "icon-item heart"
  }, [_c('mdm-icon', {
    attrs: {
      "size": "20",
      "name": "heart"
    }
  })], 1), _vm._v(" "), _c('i', {
    staticClass: "icon-item heart-full"
  }, [_c('mdm-icon', {
    attrs: {
      "size": "20",
      "name": "heart-full"
    }
  })], 1)]), _vm._v(" "), _c('span', {
    staticClass: "heart-label",
    class: {
      'sr-only': !_vm.withText
    },
    domProps: {
      "textContent": _vm._s(_vm.btnText)
    }
  })])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };